import { render, staticRenderFns } from "./PunctuationMarksForm.vue?vue&type=template&id=5b5b5d64&scoped=true&lang=pug&"
import script from "./PunctuationMarksForm.vue?vue&type=script&lang=js&"
export * from "./PunctuationMarksForm.vue?vue&type=script&lang=js&"
import style0 from "./PunctuationMarksForm.vue?vue&type=style&index=0&id=5b5b5d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b5d64",
  null
  
)

export default component.exports